import {FC} from 'react'
import {Route, RouteProps, Switch, useLocation} from 'react-router-dom'

export const RouteTransition = ({render, ...rest}: RouteProps) => {
  return <Route {...rest} render={render} />
}

type AnimatedRoutesProps = {
  children: React.ReactNode
}

export const AnimatedRoutes: FC<AnimatedRoutesProps> = ({children}) => {
  const location = useLocation()
  return (
    <Switch key={location.pathname} location={location}>
      {children}
    </Switch>
  )
}
